import { Label, Select, Checkbox } from '@/components/ui'
import { useValuationStore } from '@/store/valuationStore'
import { FLOOR_OPTIONS, CONDITION_OPTIONS } from '@/data/opzioni-immobile'

const viewOptions = [
  { value: 'nessuna', label: 'Posizione standard' },
  { value: 'parziale', label: 'Buona posizione / vista parziale' },
  { value: 'ampia', label: 'Posizione pregiata / vista panoramica' },
]

const energyClassOptions = [
  { value: 'alta', label: 'A / B (alta efficienza)' },
  { value: 'media', label: 'C / D / E (media)' },
  { value: 'bassa', label: 'F / G (bassa)' },
]

const specialTypeOptions = [
  { value: 'attico', label: 'Attico / Ultimo piano' },
  { value: 'loft', label: 'Loft / Open space' },
  { value: 'monolocale', label: 'Monolocale / Bilocale piccolo' },
]

export function CharacteristicsStep() {
  const { formData, updateFormData } = useValuationStore()

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Caratteristiche</h2>
        <p className="mt-1 text-gray-600">
          Descrivi le caratteristiche principali dell'immobile
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="floor">Piano</Label>
          <Select
            id="floor"
            value={formData.floor || ''}
            onChange={(e) => updateFormData({ floor: e.target.value || undefined })}
            options={FLOOR_OPTIONS}
            placeholder="Seleziona il piano"
          />
        </div>

        <div>
          <Label htmlFor="condition">Stato dell'immobile</Label>
          <Select
            id="condition"
            value={formData.condition || ''}
            onChange={(e) => updateFormData({ condition: e.target.value || undefined })}
            options={CONDITION_OPTIONS}
            placeholder="Seleziona lo stato"
          />
        </div>

        <div>
          <Label htmlFor="view">Posizione / Vista</Label>
          <Select
            id="view"
            value={formData.view || ''}
            onChange={(e) => updateFormData({ view: e.target.value || undefined })}
            options={viewOptions}
            placeholder="Seleziona la vista"
          />
        </div>

        <div className="flex items-end pb-2">
          <Checkbox
            id="hasElevator"
            checked={formData.hasElevator || false}
            onChange={(e) => updateFormData({ hasElevator: e.target.checked })}
            label="Presenza di ascensore"
          />
        </div>

        <div>
          <Label htmlFor="energyClass">Classe energetica</Label>
          <Select
            id="energyClass"
            value={formData.energyClass || ''}
            onChange={(e) => updateFormData({ energyClass: (e.target.value || undefined) as 'alta' | 'media' | 'bassa' | undefined })}
            options={energyClassOptions}
            placeholder="Seleziona classe energetica"
          />
        </div>

        <div>
          <Label htmlFor="specialType">Tipologia particolare</Label>
          <Select
            id="specialType"
            value={formData.specialType || ''}
            onChange={(e) => updateFormData({ specialType: (e.target.value || undefined) as 'attico' | 'loft' | 'monolocale' | undefined })}
            options={specialTypeOptions}
            placeholder="Nessuna (appartamento standard)"
          />
        </div>

        <div className="flex items-end pb-2">
          <Checkbox
            id="isRecente"
            checked={formData.isRecente || false}
            onChange={(e) => updateFormData({ isRecente: e.target.checked })}
            label="Costruzione recente (ultimi 10 anni)"
          />
        </div>
      </div>
    </div>
  )
}
